import { render } from "./MoodTrackerInstruction.vue?vue&type=template&id=1899e6ae&scoped=true"
import script from "./MoodTrackerInstruction.vue?vue&type=script&lang=js"
export * from "./MoodTrackerInstruction.vue?vue&type=script&lang=js"

import "./MoodTrackerInstruction.vue?vue&type=style&index=0&id=1899e6ae&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1899e6ae"]])

export default __exports__